module.exports = __webpack_public_path__ + "static/img/3.c112d71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/3.jpg
// module id = Lyei
// module chunks = 1